
import Vue from 'vue';

import WebhookByTriggerId from './components/setting/WebhookByTriggerId';
Vue.component(WebhookByTriggerId.name, WebhookByTriggerId);

import WebhookById from './components/setting/WebhookById';
Vue.component(WebhookById.name, WebhookById);

import WorkflowById from './components/setting/WorkflowById';
Vue.component(WorkflowById.name, WorkflowById);

import TicketUserById from './components/setting/TicketUserById';
Vue.component(TicketUserById.name, TicketUserById);

import WebhookTrigger from './components/setting/WebhookTrigger';
Vue.component(WebhookTrigger.name, WebhookTrigger);

import UserLeader from './components/setting/UserLeader';
Vue.component(UserLeader.name, UserLeader);

import UserStaff from './components/setting/UserStaff';
Vue.component(UserStaff.name, UserStaff);

import DepartmentUser from './components/setting/DepartmentUser';
Vue.component(DepartmentUser.name, DepartmentUser);

import TicketCountByTag from './components/setting/TicketCountByTag';
Vue.component(TicketCountByTag.name, TicketCountByTag);

import TicketTypeParent from './components/setting/TicketTypeParent';
Vue.component(TicketTypeParent.name, TicketTypeParent);

import TicketTypeChildren from './components/setting/TicketTypeChildren';
Vue.component(TicketTypeChildren.name, TicketTypeChildren);

import ProjectTable from './components/setting/ProjectTable';
Vue.component(ProjectTable.name, ProjectTable);


// WEBPACK FOOTER //
// ./src/components-setting.js